import './Spinner.css';

const Spinner = () => (
  <div className="spinner-overlay">
    <div className="spinner" />
  </div>
);

export default Spinner;
